// TODO refactor wersji okruszka string/fn/obj
import { useMatches, Link, UIMatch, generatePath } from "react-router";
import { useAppSelector } from "../../services/hooks";
import { Breadcrumb } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Categories } from "../../stores/categories/categories";
import { findCategoryPath } from "../../features/LandingAndCategories/Landing/Landing";

export default function Breadcrumbs() {
    const { t } = useTranslation('titles')
    const matches = useMatches();

    const productName = useAppSelector((state) => state.product.data?.name)
    const productCategory = useAppSelector((state) => state.product.data.category)
    const productDefaultCategory = useAppSelector((state) => {
        if (state.product.data.categories) {
            if (state.product.data.categories[0].name)
                return state.product.data.categories[0].name
        }
    })
    const categories = useAppSelector((state) => state.categories.data)

    //TODO moznaby raczej to zredukowac to jednej wiekszej funkcji razem z findCategoryPath
    function recurringFind(slug: string, categories: Categories): string | undefined {
        for (const category of categories) {
            // najpierw szukaj w podkategoriach
            if (category.subCategories) {
                const foundInSub = recurringFind(slug, category.subCategories);
                if (foundInSub) return foundInSub;
            }
            // jeśli nie ma w sub, dopiero teraz sprawdź bieżący slug
            if (slug === category.slug) {
                return category.name;
            }
        }
        return undefined;
    }

    const crumbs = matches
        // wybierz te routes/matches które zawierają handle.breadcrumb
        .filter((match): match is UIMatch<object, { breadcrumb: string | ((match: UIMatch) => string) | ((match: UIMatch) => { path: string; label: string }) }> =>
            Boolean((match.handle as any)?.breadcrumb)
        )
        // przejdź po tych matches i dla każdego zrób docelowy obiekt okruszka - ostatni return w map
        .map((match) => {
            // okruszek - string albo funkcja => string albo funkcja => obiekt, zależnie od tego co podane różna obsługa / każdy typ ma inne przeznaczenie
            const breadcrumb = match.handle.breadcrumb;
            // jeśli handle.breadcrumb jest funkcją zwróć funkcję inaczej null
            const breadcrumbFunction: ({ path: string; label: string } | string | null) =
                typeof breadcrumb === 'function'
                    ? breadcrumb(match)
                    : null // TODO? - niepamietam o co mi tu chodziło #marek
            const isTranslated = (breadcrumbFunction === "singleProduct");
            // zmienne na ścieżkę do linku, treśc okruszka, typ w przypadku obiektowego okruszka
            let path: string | null = ''
            let label: string | null = ''
            let type: string = 'default'

            // obsługa treści okruszka
            // jeśli okruszek jest funkcją - customowe zachowanie
            if (breadcrumbFunction) {
                path = match.pathname
                // fallback dla produktu jeśli wchodzimy na strone produktu spoza kategorii - jesli api podało defaultCategory dla produktu: podaj to, jeśli nie to puste
                if (breadcrumbFunction === 'defaultCategory') {
                    path = null //TODO
                    if (productDefaultCategory) {
                        label = `${productDefaultCategory}` //${t('title.mainCategory')}
                    } else {
                        label = ''
                    }
                }
                // obsługa route /product/x
                // ? wyciągać treść okruszka z reduxa który łączy slug z name ?
                else if (breadcrumbFunction === 'singleProduct') {
                    label = productCategory
                        ? `${findCategoryPath(categories, productCategory, '')}/${productName}`
                        : productName
                    //${t('title.singleProduct')}
                    type = 'product'
                }
                // obsługa okruszka-obiektu
                else if (typeof breadcrumbFunction === 'object') {
                    label = breadcrumbFunction.label
                    //TODO produkty / kategorie switch
                    type = 'category'
                }
                // default zwróć funkcję okruszka
                else {
                    label = breadcrumbFunction
                }
            }
            // jeśli okruszek jest stringiem - default
            else {
                path = match.pathname
                label = breadcrumb as string | null
            }

            return {
                label,
                path,
                type,
                isTranslated: isTranslated
            };
        });

    // render docelowej tablicy obiektów okruszków
    const showBreadcrumbs = crumbs.map((crumb, i) => {
        if (crumb.path && crumb.label && crumb.type) {
            // jeśli okruszek zawiera slasha, potnij po slashach i zrób z każdej części osobny okruszek
            if (crumb.label.includes('/')) {
                const megaCrumb = crumb.label.split('/')
                console.log(megaCrumb)
                let link = ''
                return megaCrumb.map((megaCrumbPart, j) => {
                    link = link + '/' + megaCrumbPart
                    return <Breadcrumb.Item
                        key={j}
                        href={generatePath('')}
                        linkAs={Link} linkProps={{ to: `/categories/${link}` }}
                        active={j + 1 === megaCrumb.length}>
                        <small>
                            <small style={{ textDecoration: 'underline' }}>
                                {//crumb.isTranslated
                                    //? crumb.label
                                    //: t(`title.${crumb.label}`)
                                    crumb.type === 'category' && recurringFind(megaCrumbPart, categories)
                                }
                                {crumb.type === 'product' && (recurringFind(megaCrumbPart, categories) ?? megaCrumbPart)}
                            </small>
                        </small>
                    </Breadcrumb.Item>
                })
            } else {
                return <Breadcrumb.Item
                    key={i}
                    href={generatePath(crumb.path)}
                    linkAs={Link} linkProps={{ to: crumb.path }}
                    active={i + 1 === crumbs.length}>
                    <small>
                        <small style={{ textDecoration: 'underline' }}>
                            {crumb.type === 'category' // To jest potrzebne jak wejdziemy w 1ną kategorię (nie ma slash ale musimy znależć category.name)
                                ? recurringFind(crumb.label, categories)
                                : crumb.isTranslated
                                    ? crumb.label
                                    : t(crumb.label)
                            }
                        </small>
                    </small>
                </Breadcrumb.Item>
            }
        }
    })

    return (<>
        {crumbs.length > 0 &&
            <div className="bg-light bg-gradient border-top border-1 px-1 border-light-subtle">
                <nav>
                    <Breadcrumb className="m-0 p-1" listProps={{ className: "m-0" }}>
                        {showBreadcrumbs}
                    </Breadcrumb>
                </nav>
            </div>
        }
    </>
    );
}

//  stare
{/* <nav style="--bs-breadcrumb-divider: '/';" aria-label="breadcrumb">
    <ol class="breadcrumb m-0 p-2" id="breadCrumb">
        <li class="breadcrumb-item">
            <a href="https://trial.romer.com.pl/lang-pl/categories/159-aplikatory" class="link-dark">
                <small>Aplikatory</small>
            </a>                        </li>
        <li class="breadcrumb-item">
            <small>Aplikator ProfiSpray Base (EU)</small>
        </li>
    </ol>
</nav> */
}


// const path =
//     breadcrumbFunction === "defaultCategory"
//         ? null
//         : match.pathname;

// const label =
//     breadcrumbFunction
//         ? breadcrumbFunction === "defaultCategory"
//             ? productDefaultCategory ? `${t('title.mainCategory')} ${productDefaultCategory}` : ''
//             : breadcrumbFunction === "singleProduct"
//                 ? `${t('title.singleProduct')} ${productName}`
//                 : typeof breadcrumbFunction === 'object'
//                     ? breadcrumbFunction.label
//                     : breadcrumbFunction
//         : breadcrumb;